<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseBasics.name')">
            <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseBasics.code')">
            <BjInput v-model="queryParams.code" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseBasics.type')">
            <BjSelectLov v-model="queryParams.type" lov-code="SPUR.PURCHASE_CONFIG" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan"></el-col>

      </template>

      <template v-slot:tableOperation>
        <el-col>
          <!-- <el-button type="primary" class="main-btn" @click="onAdd">{{
            $t('businessLogisticsCompany.common.add')
          }}
          </el-button> -->
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn"
                @click="onEdit(scope.row)">{{ $t('editText') }}
              </el-button>

              <!-- <el-button type="text" class="delete-btn" @click="onDelete(scope.row)">{{
                  $t('delText') }}
              </el-button> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import DataForm from './components/DataForm.vue';

export default {
  name: 'BusinessPurchaseBasics',
  components: {
    DataForm
  },
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: purchaseApi.getPurchaseConfig,
      // 查询参数
      queryParams: {
        code: null,
        name: null,
        type: null
      },
      labelList: [
        { label: this.$t('BusinessPurchaseBasics.name'), prop: 'name', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseBasics.code'), prop: 'code', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseBasics.value'), prop: 'data', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseBasics.type'), prop: 'type', isCheck: true, disabled: false },
        { label: this.$t('WarehouseManagement.form.Description'), prop: 'remarks', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompany.table.action'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          purchaseApi.deletePurchaseConfig({ids: [row.id]}).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
     /** 重置按钮操作 */
    beforeResetSearch() {
    this.queryParams.name = null;
    this.queryParams.type = null;
    this.queryParams.code = null;
    return new Promise(resolve => {
      resolve();
    });
  },
  },
};
</script>
<style lang="scss" scoped></style>
